import { NavLink } from 'react-router-dom';
import React from 'react'

import img1 from '../../Images/expimg (1).png';
import img2 from '../../Images/expimg (2).png';
import img3 from '../../Images/expimg (3).png';
import img4 from '../../Images/expimg (4).png';
import img5 from '../../Images/expimg (5).png';
import img6 from '../../Images/expimg (6).png';




import crdimg1 from '../../Images/icon1.png';
import crdimg2 from '../../Images/icon2.png';
import crdimg3 from '../../Images/icon3.png';
import crdimg4 from '../../Images/icon4.png';
import crdimg5 from '../../Images/icon5.png';
import crdimg6 from '../../Images/icon6.png';
import crdimg7 from '../../Images/icon7.png';


const college = [
    { link: 'After 10th Courses', path: '/c_pages/Diploma', img: img1 },
    { link: 'After 10+2 Courses', path: '/c_pages/B.Tech', img: img2 },
    { link: 'Diploma Courses', path: '/c_pages/Diploma', img: img3 },
    { link: 'Certification Courses', path: '/c_pages/Certification', img: img4 },
    { link: 'B.Tech Research Courses', path: '/c_pages/B.Tech', img: img5 },
    { link: 'Masters Degree/Post Graduation Courses', path: '/c_pages/MBA', img: img6 },
];









const Carddata = [
    {
        id: "1",
        img: crdimg1,
        title: 'Engineering',
        heading: '8585 Colleges',
        ul1: 'B.Tech',
        ul2: 'M.Tech',
        ul3: 'Diploma',
    },
    {
        id: "2",
        img: crdimg2,
        title: 'Management',
        heading: '4542 Colleges',
        ul1: 'MBA',
        ul2: 'BBA',
        ul3: 'Executive MBA',
    },
    {
        id: "3",
        img: crdimg3,
        title: 'Commerce',
        heading: '4685 Colleges',
        ul1: 'B.Com',
        ul2: 'M.Com',
        ul3: 'Diploma',
    },
    {
        id: "4",
        img: crdimg4,
        title: 'Arts',
        heading: '6353 Colleges',
        ul1: 'BA',
        ul2: 'MA',
        ul3: 'BFA',
    },
    {
        id: "5",
        img: crdimg5,
        title: 'Medical',
        heading: '2536 Colleges',
        ul1: 'MBBS',
        ul2: 'PG Medical',
        ul3: 'UG Medical',
    },
    {
        id: "6",
        img: crdimg6,
        title: 'Design',
        heading: '1525 Colleges',
        ul1: 'B.Des',
        ul2: 'M.Des',
        ul3: 'Web Design',
    },
    {
        id: "7",
        img: crdimg7,
        title: 'LAW',
        heading: '8585 Colleges',
        ul1: 'LLB',
        ul2: 'LLM',
        ul3: 'Diploma Law',
    },
];

const Ecplorecourse = () => {
    return (
        <div className="bg-gray-50 min-h-screen pb-20">
            {/* Banner */}
            <div className="bg-gradient-to-r from-orange-600 via-orange-500 to-orange-600 text-white py-20 text-center shadow-lg relative overflow-hidden">
                <div className="absolute inset-0 bg-black opacity-10 pattern-grid-lg"></div>
                <div className="container mx-auto px-4 relative z-10">
                    <h2 className="text-4xl md:text-5xl font-bold mb-4 uppercase">Search from Over 10,000 Courses in India</h2>
                    <p className="text-orange-50 max-w-2xl mx-auto text-lg">
                        Select your preferred course stream to find the best colleges, admissions, and career opportunities.
                    </p>
                </div>
            </div>

            {/* Course Levels Section */}
            <div className="container mx-auto px-4 mt-12">
                <div className="text-center mb-10">
                    <h2 className="text-3xl font-bold text-gray-800">Master New Skills with Expert Guidance</h2>
                    <div className="w-24 h-1 bg-brand-orange mx-auto mt-4 rounded-full"></div>
                    <p className="text-gray-500 mt-4 max-w-2xl mx-auto">
                        Gain insights from experienced educators and industry professionals who will guide you through real-world applications.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {college.map((item, index) => (
                        <div key={index} className="group">
                            <div className="bg-white border border-gray-200 rounded-3xl p-6 shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 h-full flex flex-col items-center text-center">
                                <div className="mb-6 p-4 bg-orange-50 rounded-full group-hover:scale-110 transition-transform duration-500">
                                    <img src={item.img} alt="College" className="w-32 h-32 object-contain filter drop-shadow-md" />
                                </div>
                                <NavLink to={item.path} className="text-xl font-bold text-gray-800 hover:text-brand-orange transition-colors">
                                    {item.link}
                                </NavLink>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Choose By Interest Section */}
            <div className="bg-white py-20 mt-20 border-t border-gray-100">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-16">
                        <h2 className="text-3xl font-bold text-gray-800 uppercase">Choose By Interest</h2>
                        <div className="w-24 h-1 bg-brand-orange mx-auto mt-4 rounded-full"></div>
                        <p className="text-gray-500 mt-4 max-w-3xl mx-auto">
                            GetFast Education is a comprehensive platform designed for students, parents, and education professionals seeking reliable information.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {Carddata.map(({ id, title, img, heading, ul1, ul2, ul3 }) => (
                            <div key={id} className="group h-full">
                                <div className="bg-gray-50 border border-gray-200 rounded-3xl p-8 hover:bg-white hover:shadow-xl hover:border-brand-orange transition-all duration-300 h-full flex flex-col">
                                    <div className="text-center mb-6">
                                        <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mx-auto shadow-sm border border-gray-100 group-hover:scale-110 transition-transform">
                                            <img src={img} alt="icon" className="w-10 h-10 object-contain" />
                                        </div>
                                    </div>
                                    <NavLink to={`/c_pages/${title}`} className="text-xl font-bold text-gray-800 text-center mb-1 hover:text-brand-orange transition cursor-pointer block">{title}</NavLink>
                                    <p className="text-sm text-gray-500 text-center mb-6 border-b border-gray-200 pb-4">
                                        {heading}
                                    </p>

                                    <ul className="space-y-3">
                                        {[ul1, ul2, ul3].map((sub, idx) => (
                                            <li key={idx} className="text-center">
                                                <NavLink
                                                    to={`/c_pages/${sub}`}
                                                    className="inline-block px-4 py-2 bg-white border border-gray-100 rounded-lg text-sm font-medium text-gray-600 hover:text-brand-orange hover:border-brand-orange hover:shadow-sm transition-all w-full"
                                                >
                                                    {sub}
                                                </NavLink>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Ecplorecourse
